export const ROLES = {
  SUPER_ADMIN: "SuperAdmin",
  ADMIN: "Admin",
  CUSTOMER_SERVICE_AGENT: "CustomerServiceAgent",
  CALL_CENTER_AGENT: "CallCenterAgent",
  EXTERNAL_CUSTOMER_SERVICE_AGENT: "ExternalCustomerServiceAgent",
  USER: "User", // Default role if no role is found
};

// azure roles
export const AZURE_ROLES = {
  "perm.su": "SuperAdmin",
  "perm.ad": "Admin",
  "perm.csa": "CustomerServiceAgent",
  "perm.cca": "CallCenterAgent",
  "perm.ecsa": "ExternalCustomerServiceAgent",
};

// Define constant for localStorage keys
export const LOCAL_STORAGE_KEYS = {
  ACCESS_TOKEN: "access_token",
  USERNAME: "username",
  ROLES: "roles",
};
